import { useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import UserContext from 'context/UserSessionContext';
import useApi, { UPDATE_WIDGET_MORE_OPTIONS } from 'hooks/useApi';
import { UPDATE_WIDGET } from 'hooks/useFetchCannedDashboard/actions';
import { mapWidgetType, updateNavigationDashboardsItem } from 'utils/widget-helpers';
import * as DASHBOARD_ACTIONS from 'hooks/useFetchCannedDashboardList/actions';

export default ({ widget, updateWidget, dashboardData, dispatchCannedDashboardList }) => {
  const history = useHistory();
  const { id } = useParams();

  const { session } = useContext(UserContext);
  const { portfolios, holdings } = session;

  const [state, makeRequest] = useApi();
  const { data, isLoading, isError } = state;

  const widgetType = widget && widget.overlay.baseWidget.widgetType.name;

  useEffect(() => {
    if (!data || isLoading || isError) {
      return;
    }

    const { id: widgetId, dashboardId } = data;
    const { masterObjectId } = dashboardData;

    const widgetMoreOptionsUpdateProps = {
      isTitleDisplayed: data.isTitleDisplayed,
      isLegendDisplayed: data.isLegendDisplayed,
      isDateDisplayed: data.isDateDisplayed,
      isChartTooltipDisplayed: data.isChartTooltipDisplayed
    };

    if (dashboardData.isCanned) {
      dispatchCannedDashboardList({
        type: DASHBOARD_ACTIONS.DASHBOARD_UPDATE_LIST_ITEM,
        payload: { currentDashboardId: id, deepCopyDashboardId: dashboardId }
      });

      // This function changes the value of user context property directly without dispatching an action! Keep in mind!
      updateNavigationDashboardsItem({ portfolios, holdings, masterObjectId, id, dashboardId });

      history.push(`/canned/${masterObjectId}/${dashboardId}`);
    } else {
      updateWidget({
        type: UPDATE_WIDGET,
        payload: {
          id: widgetId,
          data: widgetMoreOptionsUpdateProps
        }
      });
    }
  }, [data, isLoading, isError, updateWidget, dashboardData, history, dispatchCannedDashboardList]); // eslint-disable-line

  const onMoreOptionsSubmit = checkboxData => {
    const {
      masterObjectId: dashboardMasterObjectId,
      masterObjectTypeId: dashboardMasterObjectTypeId,
      objectTypeDetailId: dashboardObjectTypeDetailId
    } = dashboardData;

    const updateData = {
      id: widget.id,
      widgetType: mapWidgetType(widgetType),
      dashboardMasterObjectId,
      dashboardMasterObjectTypeId,
      dashboardObjectTypeDetailId,
      ...checkboxData
    };

    makeRequest(UPDATE_WIDGET_MORE_OPTIONS({ ...updateData }));
  };

  return [onMoreOptionsSubmit];
};
